export function showNotificationMessageIfNotConnectedToSendSpDocument() {
    if (($('#notification_if_not_connected_to_send_docomentToSp').length) && ($('#usernameNavTop').length == 0)) {
        $('#notification_if_not_connected_to_send_docomentToSp').removeClass("hidden");
        return true;
    }
    return false;
}

export function isIE() {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf('MSIE '); // IE 10 or older
    var trident = ua.indexOf('Trident/'); //IE 11
    return (msie > 0 || trident > 0);
}

export function addNotificationIfIsIe() {
    if (isIE()) {
        $($("article > h1")).after('<div id="notification_if_IE" class="alert alert-bloc alert-warning" role="alert"> <p><b>Pour avoir un fonctionnement et un affichage satisfaisant, nous vous recommandons d\'utiliser d\'autres navigateurs web.</b></p> </div>');
    }
}